var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"title":"图片剪裁","visible":_vm.value,"bodyStyle":{paddingTop: 0},"width":900,"footer":false},on:{"cancel":_vm.handleCancel}},[(_vm.value)?_c('Tailor',_vm._g(_vm._b({},'Tailor',_vm.$attrs,false),_vm.$listeners)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }